import React, { useEffect } from 'react';
import classNames from 'classnames';
import { useDispatch, useSelector } from 'react-redux';
import { Icons, Row } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import { addGlobalPopUpWrapper, clearGlobalPopUpWrapper } from '../actions';
import { POPUP_LIST_NAME } from '../../../configs';
import { intlShape } from '../../../components/base/IntlProviderWrapper';
import { getDriverData } from '../../DriverLog/reducer';
import { loadDriverCardById } from '../../DriverLog/actions';
import { dateFormatter, infoFormatterIntl, localeFormatter } from '../../../utils/formatters';
import { Accordion } from '../../../components/base/Accordion/Accordion';
import FileView from '../../../components/fields/FileInput/FileView';

export function DriverPopUp(props) {
  const dispatch = useDispatch();
  const {
    id = '',
    onClose = () => {
    },
  } = props;
  const {
    formatMessage,
  } = intlShape;

  const {
    driverCard,
    fieldsValidation = {},
  } = useSelector(getDriverData);

  const loadData = () => {
    dispatch(loadDriverCardById(id));
  };

  useEffect(loadData, []);

  const mocFile = [{
    id: 181053,
    model_type: 'application',
    model_id: '019c936e-32f6-7049-bc50-d1a362c67deb',
    collection_name: 'additional_file',
    collection_name_label: 'Дополнительные файлы',
    created_at: '2026-02-25T10:05:24.000000Z',
    file_name: 'Текстовый-документ.txt',
    mime_type: 'application/x-empty',
    name: 'Текстовый документ',
    size: 0,
    url: 'https://as-taxi.fast.its-profit.ru/media-files/181053/download',
  }];

  return (
    <div className={classNames('full-view custom-scroll-theme')}>
      <div className="full-view-header">
        <div>{formatMessage({ id: 'driver.card.menu.driver.details' })}</div>
        <Icons
          onClick={() => dispatch((clearGlobalPopUpWrapper({ key: POPUP_LIST_NAME.DRIVER_POP_UP })))}
          customIcon
          icon="close"
        />
      </div>
      <div className="full-view-content">
        <div className="view-content-wrapper">
          <div className="mb-2" />
          <Row className="row-cols-3">
            {infoFormatterIntl('last_name', driverCard?.driver_last_name)}
            {infoFormatterIntl('first_name', driverCard?.driver_first_name)}
            {infoFormatterIntl('middle_name', driverCard?.driver_middle_name)}
          </Row>
          <Row className="row-cols-3">
            {infoFormatterIntl('vehicle.external_id', driverCard?.driver_external_id)}
            {infoFormatterIntl('inn', driverCard?.driver_inn)}
            {infoFormatterIntl('birth_date', dateFormatter(driverCard?.driver_birth_date))}
          </Row>
          <Row className="row-cols-3">
            {infoFormatterIntl('citizenship', localeFormatter('citizenship.type', driverCard?.driver_citizenship))}
            {infoFormatterIntl('phone', driverCard?.driver_phone)}
            {infoFormatterIntl('email', driverCard?.driver_email)}
          </Row>
          <div className="mb-2" />
          <Accordion
            isOpen
            content={(
              <>
                <Row className="row-cols-3">
                  {infoFormatterIntl('identity_type', localeFormatter('identity.type', driverCard?.driver_identity_type))}
                  {infoFormatterIntl('identity_series', driverCard?.driver_identity_series)}
                  {infoFormatterIntl('identity_number', driverCard?.driver_identity_number)}
                </Row>
                <Row className="row-cols-3">
                  {infoFormatterIntl('identity_issue_date', dateFormatter(driverCard?.driver_identity_issue_date))}
                  {infoFormatterIntl('identity_issuer', driverCard?.driver_identity_issuer)}
                </Row>
                <Row className="row-cols-3">
                  {infoFormatterIntl('identity_issuer_code', driverCard?.driver_identity_issuer_code)}
                  {infoFormatterIntl('place_of_birth', driverCard?.driver_birth_place)}
                </Row>
                <Row className="row-cols-2 mb-2">
                  {infoFormatterIntl('driver_photo_with_identity', driverCard?.driver_photo_with_identity ? <FileView readOnly withoutMime withoutHr files={driverCard?.driver_photo_with_identity} /> : null, {}, '', 12)}
                </Row>
              </>
                    )}
            title="Документ, удостоверяюший личность водителя"
          />
          <Accordion
            isOpen
            content={(
              <>
                <Row className="row-cols-3">
                  {infoFormatterIntl('driver_license_series', driverCard?.driver_license_series)}
                  {infoFormatterIntl('driver_license_number', driverCard?.driver_license_number)}
                  {infoFormatterIntl('driver_license_valid_from_date', dateFormatter(driverCard?.driver_license_valid_from_date))}
                </Row>
                <Row className="row-cols-3">
                  {infoFormatterIntl('expiration_date', dateFormatter(driverCard?.driver_license_valid_until_date))}
                  {infoFormatterIntl('issue_created_at', dateFormatter(driverCard?.driver_license_issue_date))}
                  {infoFormatterIntl('driver_license_issuer', driverCard?.driver_license_issuer)}
                </Row>
                <Row className="row-cols-3">
                  {infoFormatterIntl('driver_license_experience', driverCard?.driver_license_experience)}
                  {infoFormatterIntl('driver_license_issuer_country', driverCard?.driver_license_issuer_country)}
                </Row>
                <Row className="row-cols-2 mb-2">
                  {infoFormatterIntl('media.driver_license_files', driverCard?.driver_license_scan ? <FileView readOnly withoutMime withoutHr files={driverCard?.driver_license_scan} /> : null, {}, '', 12)}
                </Row>
              </>
                    )}
            title="Водительское удостоверение"
          />
          <Accordion
            isOpen
            content={(
              <>
                <Row className="row-cols-3">
                  {infoFormatterIntl('criminal_record_series', driverCard?.driver_criminal_record_series)}
                  {infoFormatterIntl('criminal_record_number', driverCard?.driver_criminal_record_number)}
                  {infoFormatterIntl('criminal_record_issue_date', dateFormatter(driverCard?.driver_criminal_record_issue_date))}
                </Row>
                <Row className="row-cols-1">
                  {infoFormatterIntl('criminal_record_issuer', driverCard?.driver_criminal_record_issuer)}
                </Row>
                <Row className="row-cols-2 mb-2">
                  {infoFormatterIntl('criminal_record_scan', driverCard?.driver_criminal_record_scan ? <FileView readOnly withoutMime withoutHr files={driverCard?.driver_criminal_record_scan} /> : null, {}, '', 12)}
                </Row>
              </>
            )}
            title="Справка о наличии (отсутствии) судимости и (или) факта уголовного преследования либо о прекращении уголовного преследования"
          />
          <Accordion
            isOpen
            content={(
              <Row className="row-cols-3">
                {infoFormatterIntl('employment_contract_number', driverCard?.driver_employment_contract_number)}
                {infoFormatterIntl('employment_contract_date', dateFormatter(driverCard?.driver_employment_contract_date))}
              </Row>
            )}
            title="Трудовой договор"
          />
        </div>
      </div>
    </div>
  );
}
